import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/loading.tsx");
